import gql from 'graphql-tag'

export const fetchCountry = () => {
	return {
		query: gql`
			{
				country {
					code
					name
				}
			}
		`,
		update(data) {
			return data.country
		}
	}
}
